import { render, staticRenderFns } from "./MergeEqualGoods.vue?vue&type=template&id=18509265&scoped=true&"
import script from "./MergeEqualGoods.vue?vue&type=script&lang=js&"
export * from "./MergeEqualGoods.vue?vue&type=script&lang=js&"
import style0 from "./MergeEqualGoods.vue?vue&type=style&index=0&id=18509265&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18509265",
  null
  
)

export default component.exports